import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from '../../utils/navigation';
import {BASE_URL} from '../../constants';
import * as jwtdecode from 'jwt-decode/lib';

class SmsCallbackPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.getUserFromToken = this.getUserFromToken.bind(this);
  }

  getUserFromToken(idToken){
    let token = jwtdecode.default(idToken);
    let roles = ['sms_pickup_user'];
    return {
      user: {
        idToken: idToken,
        userName: 'Unknown',
        roles: roles,
        hasRole: (role) => {
          if(!roles){
            return false;
          }
          let filtered = roles.filter(x => x == role);
          return filtered.length > 0;
        },
      }
    };
  }

  render() {
    // decode the token manually and set the user, inspect the URL, getUser from token...
    return (
      <div></div>
    );
  }
}

SmsCallbackPage.propTypes = {
  dispatch: PropTypes.func.isRequired
};

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

export default connect(null, mapDispatchToProps)(SmsCallbackPage);
